"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MPShop
 * API documentation
 *
 * The version of the OpenAPI document: 0.0.1-alpha.58
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBasketaddonsRequestToJSON = exports.GetBasketaddonsRequestFromJSONTyped = exports.GetBasketaddonsRequestFromJSON = exports.instanceOfGetBasketaddonsRequest = void 0;
/**
 * Check if a given object implements the GetBasketaddonsRequest interface.
 */
function instanceOfGetBasketaddonsRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "basketId" in value;
    return isInstance;
}
exports.instanceOfGetBasketaddonsRequest = instanceOfGetBasketaddonsRequest;
function GetBasketaddonsRequestFromJSON(json) {
    return GetBasketaddonsRequestFromJSONTyped(json, false);
}
exports.GetBasketaddonsRequestFromJSON = GetBasketaddonsRequestFromJSON;
function GetBasketaddonsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'basketId': json['basketId'],
    };
}
exports.GetBasketaddonsRequestFromJSONTyped = GetBasketaddonsRequestFromJSONTyped;
function GetBasketaddonsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'basketId': value.basketId,
    };
}
exports.GetBasketaddonsRequestToJSON = GetBasketaddonsRequestToJSON;
